<template>


  <l-map ref="map" class="map hide_zoom_control" v-model:center="center" :zoom="zoom" @focus="emits('mapFocused')"
    @blur="emits('mapUnfocused')">
    <l-tile-layer :url="urlStreetMap" layer-type="base" name="OpenStreetMap" attribution="
        &copy; <a href='https://www.openstreetmap.org' target='_blank'>OpenStreetMap Contributors<a>, 
        &copy; <a href='https://emodnet.ec.europa.eu/en/bathymetry' target='_blank'>EMODnet Contributors<a>">
    </l-tile-layer>

    <!-- <l-wms-tile-layer v-if="layers.includes('showDepthContour')"  key="Depth data" name="Depth data" format="image/png"
      url="https://depth.openseamap.org/geoserver/openseamap/wms" :transparent=true :visible=true
      layers="openseamap:contour2,openseamap:contour"></l-wms-tile-layer>

    <l-wms-tile-layer v-if="layers.includes('showMarineProfile')" key="Depth data 2" name="Depth data 2" format="image/png"
      url="https://geoserver.openseamap.org/geoserver/gwc/service/wms" :transparent=true :visible=true
      layers="gebco2021:gebco_2021"></l-wms-tile-layer> -->

    <l-wms-tile-layer v-if="layers.includes('Bathymetric contours')" key="Depth data " name="Depth data "
      format="image/png" url="https://ows.emodnet-bathymetry.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0"
      :transparent=true :visible=true layers="emodnet:contours"></l-wms-tile-layer>

    <l-wms-tile-layer v-if="layers.includes('Mean depth in multi colour (no land)')" key="Depth data "
      name="Depth data " format="image/png"
      url="https://ows.emodnet-bathymetry.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0" :transparent=true
      :visible=true layers="emodnet:mean_multicolour"></l-wms-tile-layer>

    <l-wms-tile-layer v-if="layers.includes('High Resolution bathymetry')" key="Depth data " name="Depth data "
      format="image/png" url="https://ows.emodnet-bathymetry.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0"
      :transparent=true :visible=true layers="emodnet:hr_bathymetry"></l-wms-tile-layer>

    <l-wms-tile-layer v-if="layers.includes('Mean depth rainbow colour (no land)')" key="Depth data " name="Depth data "
      format="image/png" url="https://ows.emodnet-bathymetry.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0"
      :transparent=true :visible=true layers="emodnet:mean_rainbowcolour"></l-wms-tile-layer>

    <l-control-scale position="bottomleft" />
    <template v-for="mission in missions">
      <div v-for="vehicle in mission.vehicles">
        <MapVehicle :vehicle_id="vehicle.id" :mission_id="mission.id" :show_boats_route="show_boats_route"
          :show_wind="show_wind" :show_next_waypoint="show_next_waypoint" :show_waypoints="show_waypoints"></MapVehicle>
      </div>
    </template>

  </l-map>



</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick, defineEmits, onErrorCaptured, watchEffect, onBeforeMount } from 'vue';
import { LMap, LTileLayer, LWmsTileLayer, LControlScale, LPolyline } from '@vue-leaflet/vue-leaflet';
import { storeToRefs } from 'pinia';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-textpath'


import { usePlayMissionStore } from '@/store/playMission';
import MapVehicle from './MapVehicle.vue';
import { useNotificationStore } from '@/store/notificationStore';


const props = defineProps(['show_boats_route', 'show_next_waypoint',
  'show_waypoints', 'show_wind', 'zoomControl', 'layers', 'centerMapPoint']);
const emits = defineEmits(['mapFocused', 'mapUnfocused']);
const urlStreetMap = ref('https://tile.openstreetmap.org/{z}/{x}/{y}.png');
const zoom = ref(13);
const center = ref([28.143732, -15.456884]);


const bounds = ref(null);
const iconSize = ref(13);
const map = ref();
const loading = ref(true);

const notificationStore = useNotificationStore()
const playMissionStore = usePlayMissionStore();
const { missions, missionToFollow, indexVehicleToFollow } = storeToRefs(playMissionStore);

watch(() => props.centerMapPoint, (value, oldvalue) => {
  if (value) {
    //center.value = value;
    map.value.leafletObject.flyTo(value)
  }
})




onMounted(async () => {
  await nextTick();
  loading.value = false;
});






let positionInterval = null;

watch(missionToFollow, (value, oldvalue) => {
  if (Object.keys(value) != 0) {
    clearInterval(positionInterval);
    positionInterval = setInterval(async () => {
      try {
        if (value.is_loading) return;
        let vehicle = value.vehicles[indexVehicleToFollow.value];
        const record = await checkPosition(vehicle.records, vehicle.P, vehicle.fields);
        if (record) {
          map.value.leafletObject.panTo(record);
        } else {
          useNotificationStore().setNotification("Warning", "Cannot follow the mission—no records found for vehicle " + vehicle.name + ".", "mdi-alert", "orange");
          return;
        }
      } catch (error) {
        clearInterval(positionInterval);
        positionInterval = null;
        missionToFollow.value = {};
        notificationStore.setNotification("Error", "Error while trying to follow the vehicle during playback", "mdi-alert", "red");
      }
    }, 400);
  } else {
    clearInterval(positionInterval);
    positionInterval = null;
  }

})

const checkPosition = async (records, P, fields) => {
  const record = records[P];
  return record && record[fields.latitudeKey] != null && record[fields.longitudeKey] != null
    ? [record[fields.latitudeKey], record[fields.longitudeKey]]
    : null;
};



</script>

<style lang="stylus">
  .hide_zoom_control .leaflet-control-zoom
      visibility hidden
  
  
  
  


.leaflet-right {
    position: absolute;
    z-index: -1000;
    pointer-events: none;
}

 .map {
  height: 100vh;
  width: 100%;
}
  </style>